import { CaseFilterRequest } from '../model/case-filter-request.model';
import { Injectable } from '@angular/core';
import { SortOrderType } from '@cupoui/shared/model/enumerations/sort-order-type.model';
import { CasesFilter } from '../model/cases-filter.model';
import { CASES_ITEMS_PER_PAGE } from '@cupoui/shared/constants/pagination.constants';

@Injectable({
  providedIn: 'root'
})
export class FilterRequestService {
  caseFilterRequest: CaseFilterRequest;

  constructor() {
    this.init();
  }

  public init(): void {
    this.caseFilterRequest = new CaseFilterRequest({
      sortBy: 'createdOn',
      sortOrder: SortOrderType.desc,
      pageSize: CASES_ITEMS_PER_PAGE,
      pageIndex: 0,
      totalCases: 0,
      filter: new CasesFilter()
    });
  }
}
